import { Box, Stack, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import * as React from 'react';
import AuthApi from '../../../../../api/AuthApi';
import { useAuthContext } from '../../../../../context/auth';
import {
	ADMIN_ACCOUNT_DETAILS_HEADER,
	CHANGE_PASSWORD_ACTION_TEXT,
	CHANGE_PASSWORD_FAILURE,
	CHANGE_PASSWORD_SUCCESS,
	NAME_LABEL,
	PASSWORD_HIDDEN_TEXT,
	PASSWORD_LABEL,
	USERNAME_LABEL,
} from '../../../../../data/labelsAndMessages';
import { removeFrontEndIntegrations } from '../../../../../fe-plugins';
import ChangePasswordModal from '../../../../ChangePasswordModal';
import { errorToast, successToast } from '../../../../Toast';

interface UserInfo {
	title: string;
	data: string;
}

export default function AccountDetails() {
	const authData = useAuthContext();
	const [confirmChangePassword, setConfirmChangePassword] =
		React.useState(false);

	const authToken = authData?.adminAuthData?.authorizationToken;
	const name = authData?.adminAuthData?.displayName;

	const nameToUsername = (name: string) => {
		return name.toLowerCase().split(' ').join('.');
	};

	const logout = () => {
		removeFrontEndIntegrations(window.document);
		authData.logout();
	};

	const changePassword = async (
		oldPassword: string,
		password: string,
	): Promise<boolean> => {
		let success = false;
		try {
			await AuthApi.changeUserPassword(authToken, {
				oldPassword,
				password,
				logout: true,
			});
			setConfirmChangePassword(false);
			successToast(CHANGE_PASSWORD_SUCCESS());
			success = true;
		} catch (e) {
			console.error(e);
			errorToast(
				e.response.data.message
					? e.response.data.message
					: CHANGE_PASSWORD_FAILURE(),
			);
		} finally {
			success && logout();
		}
		return success;
	};

	const UserInfoComponent = () => {
		const userInfoArray: UserInfo[] = [
			{
				title: NAME_LABEL(),
				data: name,
			},
			{
				title: USERNAME_LABEL(),
				data: nameToUsername(name),
			},
		];

		return (
			<Stack direction='row' spacing={4}>
				{userInfoArray.map((info: UserInfo, index) => {
					return (
						<div key={index}>
							<Typography variant='body1'>{info.title}</Typography>
							<Typography variant='body1' sx={{ fontWeight: 'medium' }}>
								{info.data}
							</Typography>
						</div>
					);
				})}
			</Stack>
		);
	};

	return (
		<Stack spacing={3}>
			<Typography variant='h3' sx={{ fontWeight: 'medium', mt: 0.5 }}>
				{ADMIN_ACCOUNT_DETAILS_HEADER()}
			</Typography>
			<UserInfoComponent />
			<Stack direction='row' spacing={4}>
				<div>
					<Typography variant='body1'>{PASSWORD_LABEL()}</Typography>
					<Typography variant='body1'>{PASSWORD_HIDDEN_TEXT()}</Typography>
				</div>
				<Box sx={{ p: 1 }}>
					<Link onClick={() => setConfirmChangePassword(true)}>
						{CHANGE_PASSWORD_ACTION_TEXT()}
					</Link>
				</Box>
			</Stack>
			<ChangePasswordModal
				open={confirmChangePassword}
				onConfirm={changePassword}
				onCancel={() => setConfirmChangePassword(false)}
			/>
		</Stack>
	);
}
